import React, { useEffect, useState } from 'react'
import styled from "styled-components";
import NftImg1 from '@/assets/imgs/nfts/1.jpg'
import NftImg2 from '@/assets/imgs/nfts/2.jpg'
import NftImg3 from '@/assets/imgs/nfts/3.jpg'
import NftImg4 from '@/assets/imgs/nfts/4.jpg'
import NftImg5 from '@/assets/imgs/nfts/5.jpg'
import NftImg6 from '@/assets/imgs/nfts/6.jpg'
import GreenR from '@/assets/svg/greenR.svg'
import YellowR from '@/assets/svg/yellowR.svg'


import Cursor from '@/assets/svg/cursor.svg'
import { ethers } from "ethers";
import { ReactSVG } from 'react-svg'
import Info from "@/components/NftInfo/Modal";
import { useContractRead, useAccount, useContractReads } from 'wagmi'
import { NFTCA, nftAbi, GochaCA, gachaAbi, nftMap } from '@/utils/abi'
import Spinner from '@/components/Spinner'
import { useProvider } from 'wagmi'
import {usePrevent} from "../hooks/usePrevent";

export default function MySquad() {

  const { address } = useAccount();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nftList, setnftList] = useState([]);
  const [curObj, setObj] = useState({});
  const provider = useProvider()

  usePrevent()

  const getList = async()=> {
    const nftContract = new ethers.Contract(NFTCA, nftAbi, provider);
    let nftAmount = await nftContract.balanceOf(address);
    nftAmount = parseInt(nftAmount)


    let arr = Array(nftAmount).fill(1).map((i, idx) => idx)
    
    .map(item => nftContract.tokenOfOwnerByIndex(address, item))

    const nftTypes = await Promise.all(arr)    
    
    let tokens = nftTypes.map(item => nftContract.tokenTypes(parseInt(item)))
    let list = await Promise.all(tokens)
    
    list = list.map((item, idx)=>({
      type:item,
      tokenId:parseInt(nftTypes[idx]),
      info: nftMap[item],
    }))    

    setnftList(list && list.sort((a, b) =>  b.type - a.type))
  }
  
  useEffect(() => {
    setLoading(true)
    getList().finally(() => {
      setLoading(false)
    })
  }, [provider])
  
  const handleClick = (item)=>{    
    const obj = {
      ...item,
      address
    }
    setObj(obj)
    setIsOpen(true)
  }
  
  return (
   <>
     <Wrapper>
        <div className='main-title'>My Squad</div>
        <Spinner loading={loading}>
          <div className='col'>
           {!loading && (nftList.length ?
             <div className='list-nfts'>
               {
                 nftList.map((item, idx) => <div key={idx} className={`list-item list-item-${item.type}`} onClick={() => handleClick(item)}>
                     <div className='t'>
                       <div className='t-l'>
                         { Array(nftMap[item.type].star).fill(1).map((item, idxx) => <ReactSVG key={idxx} src={YellowR} className="yellow-svg" beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/>) }
                       </div>
                       <span className='title'>{nftMap[item.type].property}</span>
                       <div className='t-l'>
                         { Array(nftMap[item.type].star).fill(1).map((item, idxx) => <ReactSVG key={idxx} src={YellowR} className="yellow-svg" beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/>) }
                       </div>
                     </div>
                     <div className='c'>
                       <img className='index-img' src={
                         item.type === 1 ? NftImg1 : (
                           item.type === 2 ? NftImg2 : (
                             item.type === 3 ? NftImg3 :(
                               item.type === 4 ? NftImg4 : (
                                 item.type === 5 ? NftImg6 : NftImg5
                               )
                             )
                           )
                         )
                       } alt="" />
                     </div>
                     <div className='bot-text'>
                       <div className='bot-desc'>{nftMap[item.type].name} <span className='bot-id'>#{item.tokenId}</span></div>
                     </div>
                   </div>
                 )}
             </div> : 'no squad')
           }
        </div>
        </Spinner>
    </Wrapper>
      
    <Info isOpen={isOpen} handleClose={() => setIsOpen(false)} item={curObj}/>
   </>
  )
}

const Wrapper = styled.div`
  @media only screen and (max-width: 1390px) {
    .nav-wrapper {
      display: none;
    }
  }
  padding-left: 61px;
  min-width: 1280px;
  padding-top: 40px;
  .col{
    display: flex;
  }
  .main-title{
    font-weight: 600;
    font-size: 55px;
    line-height: 76px;
    color: #32DE86;
    padding-bottom: 20px;
  }
  .list-nfts{
    display: flex;
    flex-wrap: wrap;    
    padding-right: 80px;
    .list-item{
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #161616;
      border-radius: 20px;
      width: 240px;
      box-sizing: border-box;
      margin-right: 60px;
      margin-bottom: 40px;
      position: relative;
      transition: 0.2s ease-in-out;
      .cursor-svg{
        display: none;
        position: absolute;
        right: -9px;
        bottom: 39px;
      }
      &:hover{
        transform-origin: bottom;
        transform: scale(1.08, 1.08);        
        cursor: pointer;
        .cursor-svg{
          display: block;
        }
      }
      
      .index-img{
        width : 200px;
        height: 200px;
        border-radius: 20px;
        display: block;
      }
      & + .list-item-2{
        /* margin-left: 40px; */
      }
      
      margin-bottom: 40px;
      .t{
        width: 100%;
        justify-content: space-between;
        align-items: center;
        font-weight: 500;
        font-size: 19px;
        line-height: 26px;
        box-sizing: border-box;
        padding: 20px 20px 16px 20px;
      }
      .t, .t-l{
        display: flex;
      }      
      .yellow-svg{
        & + .yellow-svg{
          margin-left: 10px;
        }
      }
      &.list-item-1{
        background: rgba(74, 32, 58, 0.8);
      }
      &.list-item-2{
        background:rgba(69, 36, 154, 0.8);
      }
      &.list-item-3{
        background:rgba(134, 70, 27, 0.8);        
      }
      &.list-item-4{
        background: rgba(38, 86, 131, 0.8);        
      }
      &.list-item-5{
        background: rgba(20, 62, 37, 0.8);        
      }
      &.list-item-6{
        background: rgba(33, 101, 99, 0.8);        
      }
    }

    .bot-text{
      align-self: flex-start;
      width: 100%;
      .bot-title{
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        color: rgba(255, 255, 255, 0.6);
        padding-top: 12px;
        padding-bottom: 10px;
      }
      .bot-desc{
        font-weight: 600;
        font-size: 17px;
        line-height: 24px;
        color: #fff;      
        padding: 12px 0 16px 20px;
        text-align: left;        
        width: 100%;
        box-sizing: border-box;
      }
      .bot-id{
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        color: #32DE86;
        padding-top: 4px;
      }
    }
  }
`;
